<template>
  <span>{{ label }}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Location } from '../types';
import { toString } from '.';

export default defineComponent({
  props: {
    location: {
      type: Object as () => Location,
      required: true,
    },
  },
  computed: {
    label(): string {
      return toString(this.location);
    },
  },
});
</script>
